import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

import { tryToUpdateUserDefaultWorkspace, tryToFetchMyAccountInfo } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomSelect from '../CustomSelect/CustomSelect.js'


class UserSettingsDefaultWorkspaceForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    let current_settings = props.user.settings || {};

    let workspaces = [
      {
        label: "My Account",
        value: "me"
      }
    ];


    for(var i in props.team.cache){
      workspaces.push({
        label: props.team.cache[i].display_name,
        value: props.team.cache[i].id,
      })
    }


    this.state = {
      workspace: props.user.updateUserDefaultWorkspaceForm.lastSubmit.workspace || current_settings.workspace,
      workspaces: workspaces
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    const { dispatch, user } = this.props;

    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  componentWillReceiveProps(newprops){

    if(newprops.user.settings && !newprops.user.tryingToUpdateUserDefaultWorkspace){

    let workspaces = [
      {
        label: "My Account",
        value: "me"
      }
    ];

    for(var i in newprops.team.cache){
      workspaces.push({
        label: newprops.team.cache[i].display_name,
        value: newprops.team.cache[i].id,
      })
    }

      this.setState({
        workspace: newprops.user.settings.workspace,
        workspaces: workspaces
      })
    }
  }


  handleSubmit(e){
    const { dispatch, user, team } = this.props;

    
    dispatch(tryToUpdateUserDefaultWorkspace({
      settings: {
        workspace: team.hasTeams ? this.state.workspace : undefined
      }
    }))

    if(e) e.preventDefault();
  }

  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    if(user.tryingToFetchMyAccountInfo || !user.settings)  return <i className="fal fa-spinner-third fa-spin fa-2x"/>;

    let formDisabled = state.format == user.settings.format && state.type == user.settings.type && state.units == user.settings.units && state.private == user.settings.private;

    return (
      <div>
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleSubmit(e); 
        }}>
          <p>
            Control whether Pattycake launches into your individual account or the shared workspace of a firm that you're a part of.
          </p>

          <CustomSelect
            name="referal"
            label="Default Workspace"
            options={this.state.workspaces}
            value={this.state.workspace}
            onChange={(v)=>{ this.setState({workspace: v})}}
            placeholder="Select a default workspace."
            />
          
          <div className="list-right">
            <Button 
              submit={true} 
              size="medium" 
              disabled={formDisabled} 
              thinking={user.tryingToUpdateUserDefaultWorkspace} 
              successful={user.successfullyUpdatedUserDefaultWorkspace}
              failed={user.failedToUpdatedUserDefaultWorkspace}
              color="success" 
              display="Save Changes" 
              onClick={this.handleUpdateUserDefaultWorkspace}
            />
          </div>
        </form>
      </div>
    )
  }
}


UserSettingsDefaultWorkspaceForm = reduxForm({
  form: 'UserSettingsDefaultWorkspaceForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(UserSettingsDefaultWorkspaceForm)

UserSettingsDefaultWorkspaceForm = connect((state, ownProps) => {
  const { user, team } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    team,
    initialValues
  }
})(UserSettingsDefaultWorkspaceForm);

export default UserSettingsDefaultWorkspaceForm;


// WEBPACK FOOTER //
// ./src/components/UserSettingsDefaultWorkspaceForm/UserSettingsDefaultWorkspaceForm.js